import { useEffect } from 'react'

import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { MAPS_NO_DATA_LOCATION } from '../constants'
import { MapCoordinates } from '../types'
import { useMapsInstanceContext } from './useMapsInstanceContext'

interface HookArgs {
   currentGeoShape?: LocationValue
   shouldAnimate?: boolean
}

export const useFitBoundsInMap = (args: HookArgs) => {
   const { currentGeoShape, shouldAnimate } = args

   const { fitBounds } = useMapsInstanceContext()

   const fitGeoShapeInBounds = (geoShape: LocationValue): void => {
      const coordinates: MapCoordinates[] =
         geoShape.type === 'POINT'
            ? geoShape.value
               ? [geoShape.value]
               : []
            : geoShape.value ?? []

      fitBounds(coordinates, shouldAnimate)
   }

   const fitCurrentGeoShapeInBounds = (geoShape: LocationValue): void => {
      const hasCoordinates = !!geoShape.value

      if (hasCoordinates) fitGeoShapeInBounds(geoShape)
      else fitBounds([MAPS_NO_DATA_LOCATION])
   }

   useEffect(() => {
      if (currentGeoShape) fitCurrentGeoShapeInBounds(currentGeoShape)
   }, [])

   return {
      fitGeoShapeInBounds
   }
}
